module.exports = __webpack_public_path__ + "static/img/otter_logo.3b32b2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/otter_logo.png
// module id = BE8A
// module chunks = 2